// tslint:disable: no-invalid-template-strings
import { ActionType, createAction } from 'typesafe-actions';
import { IListObjectStore } from '../../_common/type';
import {
    EBallastRecordCode,
    TBallastBackendRecord,
    TBallastRecordFilters,
    EBallastOperationCodes,
    Params,
	TBallastTableLog,
	TTableBallastTank,
} from './@types';

enum EBallastConstants {
    FEATURE = '@ballast',
    // API = '/ballast-water-record-operations',
    API = '/api/marpol/all',
    API_FOR_LOG = '/api/ballast-water-records',
    API_FOR_TANKS = '/api/tanks',
}
enum EBallastActions {
    HISTORY_LOAD = '@ballast/:history-load',
    TABLE_LOGS_LOAD = '@ballast/:table-logs-load',
   
    HISTORY_SET = '@ballast/${history}/set',
    TABLE_LOGS_SET = '@ballast/${tableLogs}/set',

    GOTO_DASHBOARD = '@ballast/-->dashboard',
    GOTO_TANK_SPECIFIC_OPERATIONS = '@ballast/-->tank-specific-operation',
    GOTO_OPERATION_DASHBOARD = '@ballast/-->operation-dashboard',
    GOTO_SELECTED_OPERATION = '@ballast/-->selected-operation',
    GOTO_HISTORY = '@ballast/-->history',

    SET_FILTER = '@ballast/:set-filter',

    BALLAST_TANKS = '@ballast/:ballast-tanks',
    TANK_SPECIFIC_BALLAST_TANKS = '@ballast/:tank-specific-ballast-tanks/set',
    TANK_SPECIFIC_OPERATION_BALLAST_TANK_CODE = '@ballast/:tank-specific-operation-ballast-tank-code/set',
}

const ballastActions = {
    commands: {
        historyLoad: createAction(
            EBallastActions.HISTORY_LOAD,
            (providedFilters: TBallastRecordFilters) => ({ providedFilters })
        )(),
		tableLogsLoad: createAction(
            EBallastActions.TABLE_LOGS_LOAD,
			(providedFilters: TBallastRecordFilters) => ({ providedFilters })
        )(),
		ballastTanks: createAction(
            EBallastActions.BALLAST_TANKS,
            (vesselId: string, category: string) => ({ vesselId, category })
        )(),
	},
	document: {
		historySet: createAction(
			EBallastActions.HISTORY_SET,
			(history: IListObjectStore<TBallastBackendRecord>) => ({ history })
		)(),
		setFilter: createAction(EBallastActions.SET_FILTER, (filters: any) => ({
			filters,
		}))(),
		tableLogsSet: createAction(
			EBallastActions.TABLE_LOGS_SET,
			(logs: TBallastTableLog[]) => ({
				logs,
			})
		)(),
		tankSpecificBallastTanks: createAction(
            EBallastActions.TANK_SPECIFIC_BALLAST_TANKS,
            (ballastTanks: TTableBallastTank[]) => ({
                ballastTanks,
            })
        )(),
		tankSpecificOperationBallastTankCodeSet: createAction(
            EBallastActions.TANK_SPECIFIC_OPERATION_BALLAST_TANK_CODE,
            (selectedBallastTankForTableLogs: string) => ({
                selectedBallastTankForTableLogs,
            })
        )(),
    },
    routes: {
        gotoDashboard: createAction(EBallastActions.GOTO_DASHBOARD)(),
        gotoTankSpecificOperations: createAction(
            EBallastActions.GOTO_TANK_SPECIFIC_OPERATIONS,
            (tankName: string, tankId: string) => ({
                tankId,
                tankName,
            })
        )(),
        gotoOperationDashboard: createAction(
            EBallastActions.GOTO_OPERATION_DASHBOARD
        )(),
        gotoSelectedOperation: createAction(
            EBallastActions.GOTO_SELECTED_OPERATION,
            (
                recordCode: EBallastRecordCode,
                operationCode: EBallastOperationCodes,
                queryParams?: Params
            ) => ({ recordCode, operationCode, queryParams })
        )(),
        gotoHistory: createAction(EBallastActions.GOTO_HISTORY)(),
    },
    events: {},
};

export type TBallastActions = ActionType<typeof ballastActions>;
export default ballastActions;
export { EBallastConstants, EBallastActions };
